// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-members-popover .tooltip.bs-tooltip-bottom,.task-members-popover .tooltip.bs-tooltip-auto[x-placement^=bottom]{margin-top:10px}.w-60{width:60%}", ""]);
// Exports
module.exports = exports;
